import * as z from "zod/v4";

export const ConfirmCreateBundleSchema = z.object({
  recommendedProducts: z.array(z.string()),
  discountPercentage: z.number(),
});

export type ConfirmCreateBundle = z.infer<typeof ConfirmCreateBundleSchema>;
